export default "__VITE_ASSET__uDJlwncT__"